module.exports = __webpack_public_path__ + "static/media/video2.975f6355.png";